import React, { useEffect } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import LineChartBase from "components/charts/LineChartBase";
import { getSixMonthAttendanceTrend } from "../../../../../redux/overview/overviewState";
import { useDispatch, useSelector } from "react-redux";


const AttendanceTrend = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.overview.sixMonthAttendanceTrend?.data ?? []);

  useEffect(() => {
      dispatch(getSixMonthAttendanceTrend());
  }, [dispatch]);

  return (
    <HeaderComponent
      title="Attendance Trend"
      description="Monthly attendance rate percentage over 6 months"
    >
      <LineChartBase 
        data={data}
        xKey="month"
        height={300}
        yKey="percentage"
        domain={[85, 100]}
        yFormatter={(v) => `${v}%`}
        tooltipFormatter={(value) => [`${value}%`, "Attendance Rate"]}
        textSize={14} 
      />
    </HeaderComponent>
  );
};

export default AttendanceTrend;
